










import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { INotification } from '@/store/modules/ui/interfaces'

interface Data {}

interface Methods {
}

interface Computed {}
interface Props {
  notification: INotification,
  time: number
}

export default Vue.extend({
  name: 'UiNotificationItem',
  props: {
    notification: {
      type: Object,
      default: () => {}
    },
    time: {
      type: Number,
      default: () => 5000
    }
  },
  mounted () {
    setTimeout(() => {
      this.$store.dispatch('ui/removeNotification', this.$attrs.id)
    }, this.time)
  },
  methods: {
    onAction () {
      if (this.notification.action) {
        this.notification.action.handler()
      }
      this.$store.dispatch('ui/removeNotification', this.$attrs.id)
    }
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
